import { InfiniteData, keepPreviousData, useInfiniteQuery } from '@tanstack/react-query';
import { get } from 'lodash';
import {
  ListFastDealItemAgentResponse,
  FastDeal
} from '@spilca/order_ts/v1/order/model_fast_deal_pb';
import { REQUEST_TYPES, useGetRequest } from '@monorepo/requests';
import { TGRPCPromiseReject } from '@monorepo/grpc';
import { QUERY_KEYS } from '@monorepo/helpers';

const useGetListFastDealItemAgent = ({ pageSize }: { pageSize: number }) => {
  const request = useGetRequest(REQUEST_TYPES.GET_LIST_FAST_DEAL_AGENT);
  const response = useInfiniteQuery<
    ListFastDealItemAgentResponse.AsObject,
    TGRPCPromiseReject
  >({
    queryKey: [QUERY_KEYS.LIST_FAST_DEAL_AGENT, { pageSize }],
    queryFn: (queryParams) => request({ ...queryParams, pageSize }),
    placeholderData: keepPreviousData,
    staleTime: 10*60*1000,
gcTime: 2*60*1000,
    refetchOnWindowFocus: false,
    getNextPageParam: (lastPage, allPages) =>
      get(lastPage, 'pagination.totalPages', 1) > allPages.length
        ? allPages.length + 1
        : undefined
  });

  const convertDataForGrid = (
    data: InfiniteData<ListFastDealItemAgentResponse.AsObject> | undefined
  ): Array<FastDeal.AsObject> => {
    if (!data) {
      return [];
    }

    return data.pages.reduce(
      (acc: Array<FastDeal.AsObject>, page) =>
        page ? [...acc, ...page.itemsList] : acc,
      []
    );
  };

  const getTotalCount = (
    data: InfiniteData<ListFastDealItemAgentResponse.AsObject> | undefined
  ) => {
    if (!data) {
      return 0;
    }
    const [firstPage] = data.pages;
    return firstPage?.pagination?.totalItems || 0;
  };

  return { ...response, convertDataForGrid, getTotalCount };
};

export default useGetListFastDealItemAgent;
